import React from 'react'

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material'

import { useStyles } from './styles'

const YesyNoRadioGroup = ({ title, name, value, onChange }) => {
  const classes = useStyles()
  return (
    <FormControl component='fieldset' className={classes.radiosBox}>
      <FormLabel component='label' className={classes.readiosTitle}>
        {title}
      </FormLabel>
      <RadioGroup row name={name} value={value} onChange={onChange}>
        <FormControlLabel value={true} control={<Radio />} label='Yes' />
        <FormControlLabel value={false} control={<Radio />} label='No' />
      </RadioGroup>
    </FormControl>
  )
}

export default YesyNoRadioGroup
